import styles from './status.module.scss';
import colorStyles from '../../constants/user-color-constants/index.json';
import { Tooltip } from '../../common';
import clsx from 'clsx';

const UserStatusButton = ({
  status,
  color = 'gray',
  truncateLength = 16,
  isTruncate = false,
  renderExtra = () => {},
  className = '',
  style = {},
  onClick,
}) => {
  const name = typeof status === 'string' ? status?.split('') : status;
  const displayTooltip = isTruncate ? name?.length > truncateLength : false;
  const displayName = displayTooltip
    ? typeof status === 'string'
      ? `${status?.slice(0, truncateLength)} ...`
      : status
    : status;

  const renderButton = () => (
    <button
      className={clsx(styles.userStatusButton, className)}
      onClick={onClick}
      style={{
        ...colorStyles?.[color],
        ...(onClick ? { cursor: 'pointer' } : {}),
        ...style,
        wordBreak: 'keep-all',
      }}
    >
      {renderExtra()}

      {displayName}
    </button>
  );

  if (displayTooltip) {
    return <Tooltip title={status}>{renderButton()}</Tooltip>;
  }

  return renderButton();
};

export default UserStatusButton;
